import React from "react";
import { Search, Hand, FileDown, CalendarDays } from "lucide-react";

/* HeroExitRamp
   -------------
   A slim, quiet ribbon that sits immediately below the hero's trust
   strip. It catches non-course visitors (dictionary lookups, returning
   students, teachers chasing printables) within the first screen
   without diluting the course CTA above it.

   Deliberately understated: small text, no card chrome, single line on
   desktop and a wrap on mobile.
*/

const ITEMS = [
  {
    label: "BSL dictionary",
    href: "/bsl-dictionary",
    icon: Search,
    analytics: "ribbon-bsl-dictionary",
    testid: "ribbon-bsl-dictionary",
  },
  {
    label: "Sign of the Day",
    href: "/sign-of-the-day",
    icon: CalendarDays,
    analytics: "ribbon-sign-of-the-day",
    testid: "ribbon-sign-of-the-day",
  },
  {
    label: "Fingerspelling player",
    href: "/fingerspell",
    icon: Hand,
    analytics: "ribbon-free-activities",
    testid: "ribbon-free-activities",
  },
  {
    label: "Free resources",
    href: "/free-resources",
    icon: FileDown,
    analytics: "ribbon-printables",
    testid: "ribbon-printables",
  },
];

const HeroExitRamp = () => {
  return (
    <section
      id="bs-hero-ribbon"
      className="bs-hero-ribbon"
      aria-label="Other ways to explore British Sign Language"
      data-testid="hero-exit-ramp"
    >
      <div className="bs-container">
        <div className="bs-hero-ribbon__row">
          <span className="bs-hero-ribbon__intro">Find what you’re looking for</span>
          <nav className="bs-hero-ribbon__links" aria-label="Free BSL resources">
            {ITEMS.map((it, i) => {
              const Icon = it.icon;
              return (
                <React.Fragment key={it.href}>
                  <a
                    href={it.href}
                    className="bs-hero-ribbon__link"
                    data-testid={it.testid}
                    data-analytics={it.analytics}
                  >
                    <Icon size={14} aria-hidden="true" />
                    <span>{it.label}</span>
                  </a>
                  {i < ITEMS.length - 1 && (
                    <span className="bs-hero-ribbon__sep" aria-hidden="true">·</span>
                  )}
                </React.Fragment>
              );
            })}
          </nav>
        </div>
      </div>
    </section>
  );
};

export default HeroExitRamp;
